"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeCsv = exports.exportData = exports.useClientSideExport = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const date_fns_1 = require("date-fns");
/**
 * Hook for client side export. This hook handles constructing and downloading csv files.
 * It also fetches data in chunks.
 * @param config
 */
function useClientSideExport(config) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const handleExport = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        (0, DialogHelper_1.showProgressDialog)({
            title: (_a = config.title) !== null && _a !== void 0 ? _a : t('common.exporting'),
            callback: (done) => __awaiter(this, void 0, void 0, function* () {
                const localDate = (0, date_fns_1.formatISO9075)(new Date(), {
                    format: 'extended',
                    representation: 'complete',
                }).replace(' ', '-');
                try {
                    const exportedData = yield exportData(config);
                    (0, DialogHelper_1.showConfirmDialog)({
                        title: t('common.exportCompleted'),
                        content: t('common.exportCompletedContent'),
                        confirmLabel: t('common.download'),
                        onConfirm: () => {
                            var _a;
                            downloadCsvFile(exportedData, `${(_a = config.fileName) !== null && _a !== void 0 ? _a : 'export'}-${localDate}.csv`);
                        },
                    });
                }
                catch (e) {
                    (0, DialogHelper_1.handleErrorDialog)(e);
                }
                finally {
                    done();
                }
            }),
        });
    });
    return {
        handleExport,
    };
}
exports.useClientSideExport = useClientSideExport;
function exportData(config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let exportData = config.header.map(escapeCsv).join(',');
        let offset = 0;
        const limit = (_a = config.batchSize) !== null && _a !== void 0 ? _a : 100;
        while (true) {
            const { rows, total } = yield config.onFetchData({ offset, limit });
            for (const row of rows) {
                exportData += '\r\n';
                const convertedData = config.onConvertData(row);
                if (convertedData.length !== config.header.length) {
                    throw new Error('Exported row count does not match header count');
                }
                exportData += convertedData.map(escapeCsv).join(',');
            }
            if (rows.length === 0 || rows.length + offset >= total) {
                break;
            }
            offset += limit;
        }
        return exportData;
    });
}
exports.exportData = exportData;
function escapeCsv(value) {
    const escaped = (value !== null && value !== void 0 ? value : '').replace(/"/g, '""');
    return /"|,|\r\n|\n|\r/.test(escaped) ? `"${escaped}"` : escaped;
}
exports.escapeCsv = escapeCsv;
function downloadCsvFile(content, fileName) {
    const blob = new Blob([content], { type: 'text/csv' });
    const downloadLink = document.createElement('a');
    const objectURL = URL.createObjectURL(blob);
    downloadLink.href = objectURL;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(objectURL);
}
